import { render, staticRenderFns } from "./shopifyListing.vue?vue&type=template&id=c2898094"
import script from "./shopifyListing.vue?vue&type=script&lang=js"
export * from "./shopifyListing.vue?vue&type=script&lang=js"
import style0 from "./shopifyListing.vue?vue&type=style&index=0&id=c2898094&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports